export enum FilterTransactionStatusEnum {
    None = 0,
    Completed = 1,
    Pending = 2,
    Cancelled = 3
}
